import React from 'react'

import * as S from './styled'

type Props = {
  withLabel?: boolean
}

export const RulesSeparator = ({ withLabel = true }: Props) => (
  <S.Container>{withLabel && <S.Label>And</S.Label>}</S.Container>
)
